import { render, staticRenderFns } from "./TelegramHistoryList.vue?vue&type=template&id=bb7aa192&scoped=true&"
import script from "./TelegramHistoryList.vue?vue&type=script&lang=js&"
export * from "./TelegramHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./TelegramHistoryList.vue?vue&type=style&index=0&id=bb7aa192&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7aa192",
  null
  
)

export default component.exports